import React, { useEffect, useState } from "react";
import Drawer from "../shared/Drawer";

export default function LikePostDrawer({ open, step, onClose, onSave }) {
  const [reactionType, setReactionType] = useState("LIKE");
  const [postsNewerThanDays, setPostsNewerThanDays] = useState(3);
  const [skipDelayIfCannotLike, setSkipDelayIfCannotLike] = useState(false);
  const [externalReference, setExternalReference] = useState("");
  const [delay, setDelay] = useState(0);
  const [delayUnit, setDelayUnit] = useState("hours");
  const [showAdvanced, setShowAdvanced] = useState(false);

  useEffect(() => {
    if (!step) return;
    setReactionType(step.reactionType || "LIKE");
    setPostsNewerThanDays(step.postsNewerThanDays ?? 3);
    setSkipDelayIfCannotLike(Boolean(step.skipDelayIfCannotLike));
    setExternalReference(step.externalReference || "");
    setDelay(step.delay ?? 0);
    setDelayUnit(step.delayUnit || "hours");
  }, [step]);

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title="Like Post"
      footer={
        <>
          <button type="button" onClick={onClose} className="px-4 py-2 rounded-lg border text-sm">
            Dismiss
          </button>
          <button
            type="button"
            onClick={() =>
              onSave?.({
                ...step,
                reactionType,
                postsNewerThanDays: Number(postsNewerThanDays),
                skipDelayIfCannotLike,
                externalReference,
                delay: Number(delay) || 0,
                delayUnit,
                label: "Like post",
              })
            }
            className="px-4 py-2 rounded-lg bg-blue-500 text-white text-sm"
          >
            Save
          </button>
        </>
      }
    >
      <div className="space-y-4">
        <div>
          <label className="text-sm font-medium">Reaction type</label>
          <select
            value={reactionType}
            onChange={(e) => setReactionType(e.target.value)}
            className="mt-1 w-full border rounded-lg px-3 py-2 text-sm"
          >
            <option value="LIKE">👍 Like</option>
            <option value="CELEBRATE">👏 Celebrate</option>
            <option value="SUPPORT">🤗 Support</option>
            <option value="LOVE">❤️ Love</option>
            <option value="INSIGHTFUL">💡 Insightful</option>
            <option value="FUNNY">😄 Funny</option>
          </select>
        </div>
        <div>
          <label className="text-sm font-medium">Posts newer than</label>
          <select
            value={postsNewerThanDays}
            onChange={(e) => setPostsNewerThanDays(e.target.value)}
            className="mt-1 w-full border rounded-lg px-3 py-2 text-sm"
          >
            {[1, 3, 7, 14, 30].map((d) => (
              <option key={d} value={d}>
                {d} Days
              </option>
            ))}
          </select>
        </div>
        <label className="flex items-center gap-2 text-sm">
          <input
            type="checkbox"
            checked={skipDelayIfCannotLike}
            onChange={(e) => setSkipDelayIfCannotLike(e.target.checked)}
          />
          Skip delay if post cannot be liked
        </label>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="text-sm font-medium">Delay</label>
            <input
              type="number"
              min={0}
              value={delay}
              onChange={(e) => setDelay(e.target.value)}
              className="mt-1 w-full border rounded-lg px-3 py-2 text-sm"
            />
          </div>
          <div>
            <label className="text-sm font-medium">Unit</label>
            <select
              value={delayUnit}
              onChange={(e) => setDelayUnit(e.target.value)}
              className="mt-1 w-full border rounded-lg px-3 py-2 text-sm"
            >
              <option value="hours">Hours</option>
              <option value="days">Days</option>
            </select>
          </div>
        </div>
        <button type="button" className="text-sm text-blue-600" onClick={() => setShowAdvanced((v) => !v)}>
          {showAdvanced ? "Hide" : "Advanced"} settings
        </button>
        {showAdvanced ? (
          <input
            value={externalReference}
            onChange={(e) => setExternalReference(e.target.value)}
            className="w-full border rounded-lg px-3 py-2 text-sm"
            placeholder="Name your step"
          />
        ) : null}
      </div>
    </Drawer>
  );
}
